module.exports = __webpack_public_path__ + "img/section2_bg.e312c4d8.jpg";